import React from "react";
import Style from "../../../../styles/js/StyleEmergency.js";
import VictimMarker from "./markers/victim_marker.png";
import AccusedMarker from "./markers/accused_marker.png";
import VictimAlertMarker from "./markers/victim_alert_marker_0.png";
import VictimAlert1Marker from "./markers/victim_alert_marker_1.png";
import VictimAlert2Marker from "./markers/victim_alert_marker_2.png";
import { Marker, Tooltip } from 'react-leaflet'
import L from 'leaflet';
import { Grid } from "@material-ui/core";

function EmergencyMarker({ profile, mobility, alert, isVictim }) {

  const style = Style();

  // Devuelve el marcador correspondiente dependiento del estado.
  const getMarker = () => {
    if (!isVictim) {
      return AccusedMarker;
    } else if (!alert) {
      return VictimMarker;
    } else {
      if (alert.state === 0)
        return VictimAlertMarker;
      else if (alert.state === 1)
        return VictimAlert1Marker
      else
        return VictimAlert2Marker
    }
  };

  const getAge = () => {
    let now = Date.now();
    let dataAge = now - mobility.time;

    if (dataAge < 60000)
      return "Localizado hace menos de un minuto";
    else if (dataAge < 1200000) 
      return `Localizado hace ${(dataAge/60000).toFixed(0)} minutos`
    else if (dataAge < 3600000)
      return "Localizado hace menos de una hora"
    else
      return `Localizado hace ${(dataAge/3600000).toFixed(0)} horas`
      
  }

  return (
    <>
      { mobility && mobility.location && (
        <Marker className={style.marker}
        position={[mobility.location.latitude,mobility.location.longitude]}
        icon={
          new L.Icon({ 
            iconUrl: getMarker(),
            iconSize: [45,45],
            iconAnchor: new L.Point(22, 45),
          })}>
          { profile && (
            <Tooltip>
              <Grid container spacing={1} style={{textAlign: 'left', fontSize: 14}}>
                <Grid item xs={12} style={{fontSize: 10}}>
                  <b>{getAge()}</b>
                </Grid>
                <Grid item xs={12}>
                  <b>{`${profile.name} ${profile.lastName}`}</b>
                </Grid>
                { profile.phoneNumber && (
                  <Grid item xs={12}>
                    {`Tel: ${profile.phoneNumber}`}
                  </Grid>
                )}
              </Grid>
            </Tooltip>
          )}
        </Marker>
      )}
    </>
  )
};

export default EmergencyMarker;
